/* Klimaflex Skonto bei Vorkasse — schaltet das Cart-Attribut "zahlungsart".
   Daran haengen die beiden Shopify Functions aus vorkasse-app/.

   Das Snippet steckt sowohl im Cart-Drawer als auch auf der Cart-Seite, kann
   also zweimal pro Seite vorkommen. Deshalb Guard gegen doppeltes Laden und
   Event-Delegation statt Listener pro Element — nach einem Section-Update sind
   die Knoten neu. */

(function () {
  if (window.klimaflexSkontoGeladen) return;
  window.klimaflexSkontoGeladen = true;

  var ATTRIBUT = 'zahlungsart';
  var WERT = 'vorkasse';

  /* Section-Name fuer die Section-Rendering-API -> Stelle im DOM.
     Verlangt wird der Section-TYP ("main-cart-footer"), nicht der Schluessel
     aus templates/cart.json ("cart-footer") — letzterer liefert null.

     Bewusst nur diese zwei: Sie enthalten Summe und Checkbox, also alles, was
     sich beim Umschalten aendert. Positionen und Warenkorb-Bubble bleiben
     gleich; sie mitzuladen brachte nur Fehlerquellen. */
  var ZIELE = [
    { section: 'cart-drawer', wurzel: '#CartDrawer', inhalt: '.drawer__inner' },
    { section: 'main-cart-footer', wurzel: '#main-cart-footer', inhalt: null }
  ];

  document.addEventListener('change', function (ereignis) {
    var box = ereignis.target.closest ? ereignis.target.closest('[data-kf-skonto-box]') : null;
    if (!box) return;
    schalte(box);
  });

  function schalte(box) {
    var behaelter = box.closest('[data-kf-skonto]');
    var gewaehlt = box.checked;

    if (behaelter) behaelter.setAttribute('aria-busy', 'true');
    zeigeFehler(behaelter, null);

    var koerper = {
      attributes: {},
      sections: ZIELE.map(function (z) { return z.section; }).join(','),
      sections_url: window.location.pathname
    };
    /* Leerer Wert loescht das Attribut. */
    koerper.attributes[ATTRIBUT] = gewaehlt ? WERT : '';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(koerper)
    })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return antwort.json();
      })
      .then(function (zustand) {
        if (!aktualisiere(zustand && zustand.sections)) window.location.reload();
      })
      .catch(function () {
        /* Zustand zurueckdrehen, damit die Anzeige nicht luegt. */
        box.checked = !gewaehlt;
        if (behaelter) behaelter.removeAttribute('aria-busy');
        zeigeFehler(behaelter, 'Die Auswahl konnte nicht gespeichert werden. Bitte erneut versuchen.');
      });
  }

  /* Ersetzt jede Stelle, die auf dieser Seite existiert und fuer die Shopify
     Markup geliefert hat. Was fehlt, wird uebersprungen statt als Fehler
     gewertet: Die Section-API liefert je nach Seite leere Antworten (auf einer
     Produktseite gibt es keinen Cart-Footer). Erst wenn gar nichts ersetzt
     werden konnte, laedt der Aufrufer die Seite neu. */
  function aktualisiere(sections) {
    if (!sections) return false;

    var ersetzt = 0;

    for (var i = 0; i < ZIELE.length; i++) {
      var ziel = ZIELE[i];
      var vorhanden = document.querySelector(ziel.wurzel);
      if (!vorhanden) continue;

      var html = sections[ziel.section];
      if (typeof html !== 'string' || html.trim() === '') continue;

      var neu = new DOMParser().parseFromString(html, 'text/html');
      var quelle = ziel.inhalt ? neu.querySelector(ziel.inhalt) : neu.querySelector(ziel.wurzel);
      var senke = ziel.inhalt ? vorhanden.querySelector(ziel.inhalt) : vorhanden;
      if (!quelle || !senke) continue;

      senke.innerHTML = quelle.innerHTML;
      ersetzt++;
    }

    return ersetzt > 0;
  }

  function zeigeFehler(behaelter, text) {
    if (!behaelter) return;
    var feld = behaelter.querySelector('[data-kf-skonto-fehler]');
    if (!feld) return;

    if (text) {
      feld.textContent = text;
      feld.hidden = false;
    } else {
      feld.textContent = '';
      feld.hidden = true;
    }
  }
})();
